import { ISOAFF } from "../../components/Lit/acc-es-data/src/enums/affIsoCodes";
import { AWARD_CODES, TTCI_AWARD_CODES } from "../enums/award-codes";
import { MARKETS, MARKET_CODES } from "../enums/market-enums";

export const ANA_MARKETS: string[] = [MARKETS.UNITED_STATES, MARKETS.CANADA, MARKETS.DOMINICAN_REPUBLIC];

export const ANNUAL_INCENTIVES_AWARD_CODES: number[] = [
  AWARD_CODES.ANNUAL_PGG,
  AWARD_CODES.PGG_GCR,
  AWARD_CODES.FGG,
  TTCI_AWARD_CODES.PLATINUM,
  TTCI_AWARD_CODES.FOUNDERS_PLATINUM,
  TTCI_AWARD_CODES.SAPPHIRE,
  TTCI_AWARD_CODES.FOUNDERS_SAPPHIRE,
  TTCI_AWARD_CODES.IN_MARKET_EMERALD,
  TTCI_AWARD_CODES.IN_MARKET_FOUNDERS_EMERALD,
  TTCI_AWARD_CODES.IN_MARKET_DIAMOND,
  TTCI_AWARD_CODES.IN_MARKET_FOUNDERS_DIAMOND,
  AWARD_CODES.QC_GROWTH,
  AWARD_CODES.VISION_BONUS_QUALIFICATION_YEAR,
  AWARD_CODES.VISION_BONUS_TRACKING_YEAR,
];

export const ANA_MARKET_CODES: string[] = [
  MARKET_CODES.UNITED_STATES,
  MARKET_CODES.CANADA,
  MARKET_CODES.DOMINICAN_REPUBLIC,
];

export const LATAM_MARKET_CODES: string[] = [
  ISOAFF.BR,
  ISOAFF.CL,
  ISOAFF.CO,
  ISOAFF.CR,
  ISOAFF.GT,
  ISOAFF.HN,
  ISOAFF.MX,
  ISOAFF.PA,
  ISOAFF.SV,
  ISOAFF.UY,
  ISOAFF.VE,
];

export const ESAN_MARKET_CODES: string[] = [
  MARKET_CODES.AT,
  MARKET_CODES.BE,
  MARKET_CODES.BG,
  MARKET_CODES.CH,
  MARKET_CODES.CZ,
  MARKET_CODES.DE,
  MARKET_CODES.DK,
  MARKET_CODES.ES,
  MARKET_CODES.EE,
  MARKET_CODES.FI,
  MARKET_CODES.FR,
  MARKET_CODES.GB,
  MARKET_CODES.GR,
  MARKET_CODES.HR,
  MARKET_CODES.HU,
  MARKET_CODES.IE,
  MARKET_CODES.IT,
  MARKET_CODES.LT,
  MARKET_CODES.LV,
  MARKET_CODES.NL,
  MARKET_CODES.NO,
  MARKET_CODES.PL,
  MARKET_CODES.PT,
  MARKET_CODES.RO,
  MARKET_CODES.SE,
  MARKET_CODES.SI,
  MARKET_CODES.SK,
  MARKET_CODES.TR,
  MARKET_CODES.UA,
  MARKET_CODES.ZA,
];

export const ANZ_MARKET_CODES: string[] = [MARKET_CODES.AU, MARKET_CODES.NZ];

export const TH_PH_MARKET_CODES: string[] = [MARKET_CODES.TH, MARKET_CODES.PH];

export const isTHPHMarket = (aff: string) => TH_PH_MARKET_CODES.includes(aff);

export const CA_MARKET_CODES: string[] = [
  MARKET_CODES.MN,
  MARKET_CODES.KG,
  MARKET_CODES.KZ,
  MARKET_CODES.RU,
  MARKET_CODES.UZ,
];

export const MSB_MARKET_CODES: string[] = [MARKET_CODES.MY, MARKET_CODES.BN, MARKET_CODES.SG];
